import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=6f6fec5f&scoped=true&"
import script from "./addAddress.vue?vue&type=script&lang=js&"
export * from "./addAddress.vue?vue&type=script&lang=js&"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=6f6fec5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6fec5f",
  null
  
)

export default component.exports